export type SearchRequestIdentity = {
  generation: number;
  key: string;
};

export function makeSearchRequestKey(
  normalizedQuery: string,
  activeAccountId: string | null | undefined,
  retryKey: number
) {
  return JSON.stringify([normalizedQuery, activeAccountId ?? "", retryKey]);
}

export function isSearchRequestCurrent(
  request: SearchRequestIdentity,
  current: SearchRequestIdentity
) {
  return request.generation === current.generation && request.key === current.key;
}
